export function useProductHelpers() {
    const getStep = (step, items, variants, page) => {
      if(!page.step1) page = {step1: "", step2: "", step3: ""}
      switch (step) {
        case 1:
          return "Step 1: " + page.step1
        case 2:
          return Object.keys(items).length > 1 ? ("Step 2: " + page.step2) : ("Step 1: " + page.step1)
        case 3:
          return Object.keys(items).length > 1 && variants.length > 1
            ? "Step 3: " + page.step3
            : Object.keys(items).length > 1 || variants.length > 1
            ? "Step 2: " + page.step2
            : "Step 1: " + page.step1
        default:
          return ""
      }
    }
  
    const setPrice = (item, variants, activeVariants) => {
      const amount = item.PackSize.replace("x", "")
      const sale = variants[activeVariants].variant.VariantPrice
      return "$" + (amount * sale).toFixed(2)
    }
  
    const stockCheck = (items, activeItems, activeVariants) => {
      return items[activeItems].Variants[activeVariants].variant
        .inStock
    }
  
    const hasSellingPlans = (items, activeItems, activeVariants) => {
      return items[activeItems].Variants[activeVariants].variant
        .SellingPlans.length > 0
    }
  
    const getSellingPlan = (items, activeItems, activeVariants, activeSellingPlan) => {
      return items[activeItems].Variants[activeVariants].variant
        .SellingPlans[activeSellingPlan].sellingPlan.id.split("/")
        .at(-1)
    }
  
    const setProductDetails = (index, products, state) => {
      index = parseInt(index)
      state.variants = products.value[index].Variants
      state.active.items = index
      state.packs = products.value[index].Variants[0].Pack.filter(
        (obj) => obj.Active
      )
      state.images =
        products.value[index].Variants[0].variant.Gallery[0]
      state.active.variants = 0
      state.active.packs = state.Preselected
    }
  
    const getFilteredPacks = (items, activeItems, activeVariants) => {
      return items[activeItems].Variants[activeVariants].Pack.filter(
        (obj) => obj.Active
      )
    }
  
    const formatPackSize = (packSize) => {
      return packSize.replace("x", "")
    }
  
    const getVariantType = (variantName) => {
      return variantName.toLowerCase().includes("bean") ? "beans" : "ground"
    }
  
    const calculatePackDifference = (newSize, currentSize) => {
      return (
        parseInt(formatPackSize(newSize)) - parseInt(formatPackSize(currentSize))
      )
    }
  
    const validateSubscriptionCheckbox = (isChecked, isSubscription) => {
      return !isChecked && isSubscription
    }
  
    const getImageUrl = (variant) => {
      return variant?.Gallery[0] || null
    }
  
    const findUpgradeOffer = (products, activeItems, activeVariants, currentPackSize) => {
      return products[activeItems]?.Variants[activeVariants]?.Pack?.filter(
        (obj) => obj.PackSize === `x${formatPackSize(currentPackSize) * 2}`
      )
    }

    const calculatePriceTimesPack = (itemPrice, itemSize) => {
      const price = Number(itemPrice.replace('$', '')) 
      const packSize = Number(itemSize.replace("x", ''))
      return (price * packSize).toFixed(2)
    }
    const findMatchingUpgradeOffer = (upgradeOffers, packSize) => {
      return upgradeOffers.filter((obj) => obj.PackSizeRun === packSize)
    }
  
    return {
      getStep,
      setPrice,
      stockCheck,
      hasSellingPlans,
      getSellingPlan,
      setProductDetails,
      getFilteredPacks,
      formatPackSize,
      getVariantType,
      calculatePackDifference,
      validateSubscriptionCheckbox,
      getImageUrl,
      findUpgradeOffer,
      calculatePriceTimesPack,
      findMatchingUpgradeOffer
    }
  }